export default "__VITE_ASSET__CstmDmla__";